import { CustomArray } from "../../../common/CustomArray";
import {AdminsItemInfo} from "./AdminsItemInfo"
 
export class AdminsItemInfos extends CustomArray {

	constructor() {
		super();
	}

	/**
		 *获得树状结构对象  
		 * @param jsonItems
		 * @return 
		 * 
		 */
	static GetTreeAdminsItems(jsonItems) {
		let curItems=null;
		if(jsonItems==null)return curItems;

		curItems=new AdminsItemInfos();
		let tempItem=null;
		for (let tempIndex in jsonItems) 
		{
			tempItem = AdminsItemInfo.GetTreeAdminsItem(jsonItems[tempIndex]);
			curItems.push(tempItem);
		}
		
		return curItems;
	}

	/**
	 *解析jsonItem的集合 
	 * @param jsonItems
	 * @return 
	 */
	static GetAdminsItems(jsonItems) {
		let curItems=null;
		if(jsonItems==null)return curItems;

		curItems=new AdminsItemInfos();
		let tempItem=null;
		for (let tempIndex in jsonItems) 
		{
			tempItem = AdminsItemInfo.GetAdminsItem(jsonItems[tempIndex]);
			curItems.push(tempItem);
		}
		
		return curItems;
	}

}